import { render, staticRenderFns } from "./label-title.vue?vue&type=template&id=7922e2ed&scoped=true"
import script from "./label-title.vue?vue&type=script&lang=js"
export * from "./label-title.vue?vue&type=script&lang=js"
import style0 from "./label-title.vue?vue&type=style&index=0&id=7922e2ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7922e2ed",
  null
  
)

export default component.exports